import { $,_,Marionette,Foundation } from '../../vendor';
// @ts-ignore
import InboomaBaseView from '../views/InboomaBaseView';
// @ts-ignore
import NotificationTpl from '../templates/NotificationTpl.html';

const NotificationView = InboomaBaseView.extend({

  template : NotificationTpl,

  defaults : {
      message : '',
      closeable : false,
      duration : 0, // in ms
      showMessageDelay : 0,
      classes : '',
      type : 'default', // default, loading, warning, success, alert
      icon : '',
      customEvents : {}, // === events, but named customEvents to avoid Backbone.js issues
      onClose : _.noop,
  },

  ui : {
      close : '.inb-notification--close',
  },

  /**
   *   attachElContent (html) {
    this.el.insertAdjacentHTML('beforeend',html);
  },
   */

  events (): any {
      return {
          'click @ui.close' : 'close',
          ...this.getOption('customEvents')
      }
  },

  templateContext (): any {
      this.options.message = _.template(this.options.message)({ t : this.t })
      return this.options;
  },

  initialize (): void {
      this.options = $.extend({}, this.defaults, this.options);
      this.render();
  },

  close (): void {
    
      const that = this;

      Foundation.Motion.animateOut(this.$el, 'scale-out-down', () => {

        that.destroy();
        that.options.onClose();

      });
  },

  onRender (): void {

      const that = this;

      // Disabled animation effect (performance bottleneck)
      //if (this.options.message !== '')
      //    setInterval(function(){that.$el.find('.inb-notification--message').addClass('active')}, this.options.showMessageDelay);

      if (this.options.duration > 0)
          setInterval(function(){that.close();}, this.options.duration);

      // The following animation is very render intensive
      // -> commented
      //Foundation.Motion.animateIn(this.$el, 'fade-in');

  }

}); 

// @ts-ignore
export default Marionette.Object.extend({
    // Without this, multiple notifications in one div
    // would not be possible

    notification : {},

    initialize (): any {

      this.notification = new NotificationView(this.options);
      $('#inb-notifications').append(this.notification.el);
    
      return this;
    },

    close (): void {
      this.notification.close();
    }

});